// import React, { useEffect, useState } from "react";
// import navHeaderLogo from "../../assets/sideBar/navHeaderLogo.svg";
// import navHeaderLogoIcon from "../../assets/sideBar/navHeaderLogoIcon.svg";
// import { motion, AnimatePresence } from "framer-motion";
// import { Link, useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { getItem } from "../../utils/localStorageUtils";

// const SidebarMenuItems = ({ items, isCollapsed }) => {
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const location = useLocation();

//   return (
//     <div className="flex flex-col gap-0">
//       {items.map((item, key) => {
//         const isActive = item.link && location.pathname.startsWith(item.link);

//         return (
//           <div key={key} className="w-full">
//             {item.function ? (
//               <button
//                 onClick={item.function}
//                 className="w-full flex gap-2 py-3 px-6 hover:bg-primary-50 group relative"
//                 onMouseEnter={() => isCollapsed && setHoveredItem(key)}
//                 onMouseLeave={() => setHoveredItem(null)}
//               >
//                 <span className="material-symbols-rounded text-[24px] font-thin text-white group-hover:text-black">
//                   {item.icon}
//                 </span>
//                 <span
//                   className={`text-[16px] font-normal text-white group-hover:text-black ${
//                     isCollapsed ? "hidden" : "block"
//                   }`}
//                 >
//                   {item.title}
//                 </span>
//                 <AnimatePresence>
//                   {isCollapsed && hoveredItem === key && (
//                     <motion.div
//                       initial={{ opacity: 0, x: -20 }}
//                       animate={{ opacity: 1, x: 0 }}
//                       exit={{ opacity: 0, x: -20 }}
//                       transition={{ duration: 0.2 }}
//                       className="absolute left-[100%] top-0 p-2 flex items-center h-full rounded text-xs whitespace-nowrap z-50"
//                     >
//                       <div className="bg-black text-white rounded flex flex-1 p-3">
//                         {item.title}
//                       </div>
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </button>
//             ) : (
//               <Link
//                 to={item.link}
//                 className={`flex gap-2 py-3 px-6 group relative ${
//                   isActive ? "bg-primary text-white" : "hover:bg-primary-50"
//                 }`}
//                 onMouseEnter={() => isCollapsed && setHoveredItem(key)}
//                 onMouseLeave={() => setHoveredItem(null)}
//               >
//                 <span
//                   className={`material-symbols-rounded text-[24px] font-thin ${
//                     isActive
//                       ? "text-white"
//                       : "text-white group-hover:text-black"
//                   }`}
//                 >
//                   {item.icon}
//                 </span>
//                 <span
//                   className={`text-[16px] font-normal ${
//                     isActive
//                       ? "text-white"
//                       : "text-white group-hover:text-black"
//                   } ${isCollapsed ? "hidden" : "block"}`}
//                 >
//                   {item.title}
//                 </span>
//                 <AnimatePresence>
//                   {isCollapsed && hoveredItem === key && (
//                     <motion.div
//                       initial={{ opacity: 0, x: -20 }}
//                       animate={{ opacity: 1, x: 0 }}
//                       exit={{ opacity: 0, x: -20 }}
//                       transition={{ duration: 0.2 }}
//                       className="absolute left-[100%] top-0 p-2 flex items-center h-full rounded text-xs whitespace-nowrap z-50"
//                     >
//                       <div className="bg-black text-white rounded flex flex-1 p-3">
//                         {item.title}
//                       </div>
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </Link>
//             )}
//           </div>
//         );
//       })}
//     </div>
//   );
// };
// const navLinkData = [
//   { icon: "bar_chart_4_bars", title: "Dashboard", link: "/dashboard" },
//   { icon: "badge", title: "Employee", link: "/employee" },
//   { icon: "punch_clock", title: "Timesheets", link: "/timesheet" },
//   { icon: "person_apron", title: "Clients", link: "/client" },
//   { icon: "supervisor_account", title: "Vendors", link: "/vendor" },
//   { icon: "receipt_long", title: "Invoices", link: "/invoices" },
//   { icon: "flight", title: "Immigration", link: "/immigration" },
//   {
//     icon: "account_balance_wallet",
//     title: "Accounts Payable",
//     link: "/accounts-payable",
//   },
//   { icon: "transit_ticket", title: "E-Onboarding", link: "/e-onboarding" },

//   { icon: "data_table", title: "Payroll", link: "/payroll" },
//   { icon: "payments", title: "Payments", link: "/payments" },
//    {
//       icon: "storefront",
//       title: "Incentive",
//       link: "/incentive",
//     },
// ];

// const bsNavLinkData = [
//   { icon: "bar_chart_4_bars", title: "Dashboard", link: "/ats/dashboard" },
//   { icon: "tenancy", title: "Leads", link: "/ats/leads" },
//   {
//     icon: "article_person",
//     title: "Account Details",
//     link: "/ats/account-details",
//   },
//   {
//     icon: "groups",
//     title: "Campaigns",
//     link: "/ats/campaigns",
//   },
//   {
//     icon: "business_center",
//     title: "Jobs",
//     link: "/ats/jobs",
//   },
//   {
//     icon: "demography",
//     title: "Applicants",
//     link: "/ats/applicants",
//   },
// ];
// const atsNavLinkData = [
//   { icon: "bar_chart_4_bars", title: "Dashboard", link: "/ats/dashboard" },
//   { icon: "tenancy", title: "Leads", link: "/ats/leads" },
//   {
//     icon: "article_person",
//     title: "Account Details",
//     link: "/ats/account-details",
//   },
//   {
//     icon: "groups",
//     title: "Campaigns",
//     link: "/ats/campaigns",
//   },
//   {
//     icon: "business_center",
//     title: "Jobs",
//     link: "/ats/jobs",
//   },
//   {
//     icon: "demography",
//     title: "Applicants",
//     link: "/ats/applicants",
//   },
// ];

// export const UserRoles = {
//   1: "ADMIN",
//   2: "RA",
//   3: "BDM",
//   4: "RECRUITER",
//   5: "EMPLOYEE",
//   6: "HR",
//   7: "FINANCE",
//   8: "IMMIGRATION",
//   30: "OTHER",
// };
// export const roleBasedAccess = {
//   ADMIN: navLinkData.map((item) => item.title),
//   HR: ["Dashboard", "Employee", "Timesheets", "Clients", "Vendors"],
//   FINANCE: navLinkData
//     .filter((item) => item.title !== "Immigration")
//     .map((item) => item.title),
//   IMMIGRATION: ["Dashboard", "Employee", "Clients", "Vendors", "Immigration"],
//   EMPLOYEE: ["Timesheets"],
// };
// const Sidebar = ({ isCollapsed, setIsCollapsed }) => {
//   const currentUserDetails = useSelector((state) => state.auth.user) || {};
//   const [showFullLogo, setShowFullLogo] = useState(false);
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const [visibleSideBarSections, setVisibleSideBarSections] = useState([]);
//   ////////
//   const toggleSidebarHandler = () => {
//     setIsCollapsed(!isCollapsed);
//     setShowFullLogo(!showFullLogo);
//   };

//   const navSettingLinks = [
//     {
//       icon: "category_search",
//       title: "Components List",
//       link: "/components-list",
//     },
//     { icon: "settings", title: "Settings", link: "/settings" },
//     {
//       icon: isCollapsed ? "keyboard_tab" : "keyboard_tab_rtl",
//       title: "Collapse",
//       function: toggleSidebarHandler, // Pass function reference here
//     },
//   ];

//   useEffect(() => {
//     const visibleSideBarSections = () => {
//       const role = UserRoles[currentUserDetails?.data?.role?.type];
//       const allowedTitles = roleBasedAccess[role] || ["Dashboard"];
//       const data =
//         navLinkData.filter((item) => allowedTitles.includes(item.title)) || [];
//       setVisibleSideBarSections(data);
//       // return data || [];
//     };
//     visibleSideBarSections();
//   }, [currentUserDetails?.data?.role]);
//   return (
//     <div className="bg-dark w-full h-screen text-white flex flex-col relative">
//       <div className="py-8 px-6 flex justify-center items-center">
//         <img
//           src={showFullLogo ? navHeaderLogo : navHeaderLogoIcon}
//           alt="Logo"
//           className={`transition-all duration-700 h-8 ${
//             showFullLogo ? "opacity-100 scale-100" : "opacity-100 scale-100"
//           }`}
//         />
//       </div>
//       <div className="flex-1 relative">
//         {/* <SidebarMenuItems items={navLinkData} isCollapsed={isCollapsed} /> */}
//         {/* if  portal=wf then visibleSideBarSections else if ats then atsNavLinkData else [] */}

//         {/* <SidebarMenuItems
//           items={visibleSideBarSections}
//           isCollapsed={isCollapsed}
//         />
//         <SidebarMenuItems items={atsNavLinkData} isCollapsed={isCollapsed} /> */}
//         {/* {localStorage.getItem("portal") === "wf" ? ( */}
//         {getItem("portal") === "wf" ? (
//           <SidebarMenuItems
//             items={visibleSideBarSections}
//             isCollapsed={isCollapsed}
//           />
//         ) : // ) : localStorage.getItem("portal") === "ats" ? (
//         getItem("portal") === "ats" ? (
//           <SidebarMenuItems items={atsNavLinkData} isCollapsed={isCollapsed} />
//         ) : // ) : localStorage.getItem("portal") === "ats" ? (
//         getItem("portal") === "bs" ? (
//           <SidebarMenuItems items={bsNavLinkData} isCollapsed={isCollapsed} />
//         ) : null}
//       </div>
//       <div className="border-t-2 border-t-neutrals-900">
//         <SidebarMenuItems items={navSettingLinks} isCollapsed={isCollapsed} />
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useEffect, useState } from "react";
import navHeaderLogo from "../../assets/sideBar/navHeaderLogo.svg";
import navHeaderLogoIcon from "../../assets/sideBar/navHeaderLogoIcon.svg";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getItem } from "../../utils/localStorageUtils";
import { createPortal } from "react-dom";
import axiosRequest from "../../redux/slices/universal/axiosService";
import { WORKFORCE_API_URL } from "../../redux/apiConfig";
import { setOffTrxAccessUsers } from "../../redux/slices/auth/authSlice";

const SidebarMenuItems = ({ items, isCollapsed }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [tooltip, setTooltip] = useState(null);
  const location = useLocation();

  const handleMouseEnter = (e, key, title) => {
    console.log({isCollapsed})
    if (!isCollapsed) return;
    const rect = e.currentTarget.getBoundingClientRect();
    setHoveredItem(key);
    setTooltip({
      title,
      top: rect.top,
      left: rect.right,
      height: rect.height,
    });
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
    setTooltip(null);
  };

  return (
    <div className="flex flex-col gap-0">
      {items.map((item, key) => {
        const isActive = item.link && location.pathname.startsWith(item.link);

        return (
          <div key={key} className="w-full">
            {item.function ? (
              <button
                onClick={item.function}
                className="w-full flex gap-2 py-3 px-6 hover:bg-primary-50 group relative"
                onMouseEnter={(e) => handleMouseEnter(e, key, item.title)}
                onMouseLeave={handleMouseLeave}
              >
                <span className="material-symbols-rounded text-[24px] font-thin text-white group-hover:text-black">
                  {item.icon}
                </span>
                <span
                  className={`text-[16px] font-normal text-white group-hover:text-black ${
                    isCollapsed ? "hidden" : "block"
                  }`}
                >
                  {item.title}
                </span>
              </button>
            ) : (
              <Link
                to={item.link}
                className={`flex gap-2 py-3 px-6 group relative ${
                  isActive ? "bg-primary text-white" : "hover:bg-primary-50"
                }`}
                onMouseEnter={(e) => handleMouseEnter(e, key, item.title)}
                onMouseLeave={handleMouseLeave}
              >
                <span
                  className={`material-symbols-rounded text-[24px] font-thin ${
                    isActive
                      ? "text-white"
                      : "text-white group-hover:text-black"
                  }`}
                >
                  {item.icon}
                </span>
                <span
                  className={`text-[16px] font-normal ${
                    isActive
                      ? "text-white"
                      : "text-white group-hover:text-black"
                  } ${isCollapsed ? "hidden" : "block"}`}
                >
                  {item.title}
                </span>
              </Link>
            )}
          </div>
        );
      })}
      {isCollapsed &&
        createPortal(
          <AnimatePresence>
            {tooltip && (
              <motion.div
                key={hoveredItem}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.2 }}
                className="fixed p-2 flex items-center rounded text-xs whitespace-nowrap pointer-events-none z-50"
                style={{
                  top: tooltip.top + tooltip.height / 2,
                  left: tooltip.left + 8,
                  translate: "0 -50%",
                }}
              >
                <div className="bg-black text-white rounded flex flex-1 p-3">
                  {tooltip.title}
                </div>
              </motion.div>
            )}
          </AnimatePresence>,
          document.body,
        )}
    </div>
  );
};
const navLinkData = [
  { icon: "bar_chart_4_bars", title: "Dashboard", link: "/dashboard" },
  { icon: "badge", title: "Employee", link: "/employee" },
  { icon: "punch_clock", title: "Timesheets", link: "/timesheet" },
  { icon: "person_apron", title: "Clients", link: "/client" },
  { icon: "supervisor_account", title: "Vendors", link: "/vendor" },
  { icon: "receipt_long", title: "Invoices", link: "/invoices" },
  { icon: "flight", title: "Immigration", link: "/immigration" },
  {
    icon: "account_balance_wallet",
    title: "Accounts Payable",
    link: "/accounts-payable",
  },
  { icon: "transit_ticket", title: "E-Onboarding", link: "/e-onboarding" },

  { icon: "data_table", title: "Payroll", link: "/payroll" },
  { icon: "payments", title: "Payments", link: "/payments" },
  {
    icon: "storefront",
    title: "Incentive",
    link: "/incentive",
  },
  {
    icon: "currency_exchange",
    title: "Off Trx",
    link: "/off-trx",
  },
];

const nmNavLinkData = [
  { icon: "bar_chart_4_bars", title: "Dashboard", link: "/ats/dashboard" },
  { icon: "tenancy", title: "Leads", link: "/ats/leads" },
  {
    icon: "article_person",
    title: "Account Details",
    link: "/ats/account-details",
  },
  {
    icon: "groups",
    title: "Campaigns",
    link: "/ats/campaigns",
  },
  {
    icon: "business_center",
    title: "Jobs",
    link: "/ats/jobs",
  },
  {
    icon: "demography",
    title: "Applicants",
    link: "/ats/applicants",
  },
];

const bsNavLinkData = [
  { icon: "bar_chart_4_bars", title: "Dashboard", link: "/ats/dashboard" },
  { icon: "tenancy", title: "Leads", link: "/ats/leads" },
  {
    icon: "article_person",
    title: "Account Details",
    link: "/ats/account-details",
  },
  {
    icon: "groups",
    title: "Campaigns",
    link: "/ats/campaigns",
  },
  {
    icon: "business_center",
    title: "Jobs",
    link: "/ats/jobs",
  },
  {
    icon: "demography",
    title: "Applicants",
    link: "/ats/applicants",
  },
];
const atsNavLinkData = [
  { icon: "bar_chart_4_bars", title: "Dashboard", link: "/ats/dashboard" },
  { icon: "tenancy", title: "Leads", link: "/ats/leads" },
  {
    icon: "article_person",
    title: "Account Details",
    link: "/ats/account-details",
  },
  {
    icon: "groups",
    title: "Campaigns",
    link: "/ats/campaigns",
  },
  {
    icon: "business_center",
    title: "Jobs",
    link: "/ats/jobs",
  },
  {
    icon: "demography",
    title: "Applicants",
    link: "/ats/applicants",
  },
];

export const UserRoles = {
  1: "ADMIN",
  2: "RA",
  3: "BDM",
  4: "RECRUITER",
  5: "EMPLOYEE",
  6: "HR",
  7: "FINANCE",
  8: "IMMIGRATION",
  30: "OTHER",
};
export const roleBasedAccess = {
  ADMIN: navLinkData.map((item) => item.title),
  HR: ["Dashboard", "Employee", "Timesheets", "Clients", "Vendors"],
  FINANCE: navLinkData
    .filter((item) => item.title !== "Immigration" && item.title !== "Off Trx")
    .map((item) => item.title),
  IMMIGRATION: ["Dashboard", "Employee", "Clients", "Vendors", "Immigration"],
  EMPLOYEE: ["Timesheets"],
};
const Sidebar = ({ isCollapsed, setIsCollapsed }) => {
  const currentUserDetails = useSelector((state) => state.auth.user) || {};
  const offTrxAccessUsers = useSelector((state) => state.auth.offTrxAccessUsers) || [];
  const dispatch = useDispatch();
  const [showFullLogo, setShowFullLogo] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [visibleSideBarSections, setVisibleSideBarSections] = useState([]);
  ////////

  {console.log("is collapesedfdfdf")}
  const toggleSidebarHandler = () => {
    setIsCollapsed(!isCollapsed);
    setShowFullLogo(!showFullLogo);
  };

  useEffect(() => {
    const fetchAccess = async () => {
      try {
        const res = await axiosRequest({ method: "GET", url: `${WORKFORCE_API_URL}/off-trx/access` });
        dispatch(setOffTrxAccessUsers(res?.data?.data?.userIds || []));
      } catch (err) {}
    };
    fetchAccess();
  }, [dispatch]);

  const navSettingLinks = [
    {
      icon: "category_search",
      title: "Components List",
      link: "/components-list",
    },
    { icon: "settings", title: "Settings", link: "/settings" },
    {
      icon: isCollapsed ? "keyboard_tab" : "keyboard_tab_rtl",
      title: "Collapse",
      function: toggleSidebarHandler, // Pass function reference here
    },
  ];

  useEffect(() => {
    const visibleSideBarSections = () => {
      const role = UserRoles[currentUserDetails?.data?.role?.type];
      let allowedTitles = [...(roleBasedAccess[role] || ["Dashboard"])];
      const uiid = currentUserDetails?.data?.uiid;
      console.log({ allowedTitles, role })
      if (role === "ADMIN" || offTrxAccessUsers.includes(uiid)) {
        if (!allowedTitles.includes("Off Trx")) allowedTitles.push("Off Trx");
      }

      const data =
        navLinkData.filter((item) => allowedTitles.includes(item.title)) || [];
      setVisibleSideBarSections(data);
      {data && console.log("visibleSideBarSections", data)}
      // return data || [];
    };
    visibleSideBarSections();
  }, [currentUserDetails?.data?.role, offTrxAccessUsers]);

  return (
    <div className="bg-[#101A26]! w-full h-full text-white flex flex-col relative">
      <div className="py-8 px-6 flex justify-center items-center">
        <img
          src={showFullLogo ? navHeaderLogo : navHeaderLogoIcon}
          alt="Logo"
          className={`transition-all duration-700 h-8 ${
            showFullLogo ? "opacity-100 scale-100" : "opacity-100 scale-100"
          }`}
        />
      </div>
      <div className="flex-1 relative overflow-y-auto overflow-x-hidden">
        {/* <SidebarMenuItems items={navLinkData} isCollapsed={isCollapsed} /> */}
        {/* if  portal=wf then visibleSideBarSections else if ats then atsNavLinkData else [] */}

        {/* <SidebarMenuItems
          items={visibleSideBarSections}
          isCollapsed={isCollapsed}
        />
        <SidebarMenuItems items={atsNavLinkData} isCollapsed={isCollapsed} /> */}
        {/* {localStorage.getItem("portal") === "wf" ? ( */}
        {getItem("portal") === "wf" ? (
          <SidebarMenuItems
            items={visibleSideBarSections}
            isCollapsed={isCollapsed}
          />
        ) : // ) : localStorage.getItem("portal") === "ats" ? (
        getItem("portal") === "ats" ? (
          <SidebarMenuItems items={atsNavLinkData} isCollapsed={isCollapsed} />
        ) : // ) : localStorage.getItem("portal") === "ats" ? (
        getItem("portal") === "bs" ? (
          
          <SidebarMenuItems items={bsNavLinkData} isCollapsed={isCollapsed} />
        ) : getItem("portal") === "nm" ? (
          <>
            
            <SidebarMenuItems items={nmNavLinkData} isCollapsed={isCollapsed} />
          </>
        ) : null}
      </div>
      {console.log(isCollapsed)}

      <div className="border-t-2 border-t-neutrals-900">
        <SidebarMenuItems items={navSettingLinks} isCollapsed={isCollapsed} />
      </div>
    </div>
  );
};

export default Sidebar;
